module.exports = __webpack_public_path__ + "static/media/investpic3@2x.55fedb7a.png";